import apiConfig from "../../config/apiConfig";
import apiConfigWthFormData from "../../config/apiConfigWthFormData";
import { objToQueryString, showSuccessToasts } from "../../services/helpers/Helper";
import { END_POINT, POST_TYPE } from "../constants";
import { setError } from "./errorAction";
import { hideLoading, showLoading } from "./loadingAction";

export const fetchPosts = () =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      clientType: '',
      revision: '',
      languageCode: '',
      countryCode: '',
      timestamp: new Date().getTime()
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.LIST_POST}?${qs}`;
    dispatch(showLoading());
    apiConfig.get(endPoint).then((response) => {
      dispatch({
        type: POST_TYPE.FETCH,
        payload: response.data
      })
    }).catch((error) => {
      dispatch(setError(error.message));
      dispatch({
        type: POST_TYPE.FETCH,
        payload: []
      })
    }).finally(() => {
      dispatch(hideLoading());
    });
  };

export const fetchPostReels = () =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
    }
    const qs = objToQueryString(params);
    const endPoint = `${END_POINT.LIST_REELS}?${qs}`;
    dispatch(showLoading());
    apiConfig.get(endPoint).then((response) => {
      dispatch({
        type: POST_TYPE.FETCH,
        payload: response.data
      })
    }).catch((error) => {
      dispatch(setError(error.message));
      dispatch({
        type: POST_TYPE.FETCH,
        payload: []
      })
    }).finally(() => {
      dispatch(hideLoading());
    });
  };


export const postOnFeed = (message) =>
  async (dispatch, getState) => {
    const { page } = getState();
    const params = {
      fb_page_id: page.social_id,
      message
    }
    dispatch(showLoading());
    apiConfigWthFormData.post(END_POINT.POST_ON_FEED, params).then((response) => {
      showSuccessToasts('Đăng bài thành công');
      // dispatch({
      //   type: POST_TYPE.FETCH,
      //   payload: response.data
      // })
    }).catch((error) => {
      dispatch(setError(error.message))
    }).finally(() => {
      dispatch(hideLoading());
    });
  };